// extracted by mini-css-extract-plugin
export default {"container":"foodEdit_container__xWfku","content":"foodEdit_content__bfD6+","form":"foodEdit_form__gs72Q","image_link":"foodEdit_image_link__E5CAC"};